<div class="new-container">
    <mat-icon *ngIf="show" svgIcon="new_file_indicator" class="new-file-indicator"></mat-icon>
    <ng-content></ng-content>
</div>
